import { Box, Container } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import EventSectionTitle from "../../components/EventSectionTitle";
import EventSetupStepper from "../../components/EventSetupStepper";
import EventTabPanel from "../../components/EventTabPanel";
import Page from "../../components/Page";
import useEvent from "../../hooks/useEvent";
import useRegFields from "../../hooks/useRegFields";
import { TABS_LIST } from "./config";
import { valSchemaBrand, valSchemaInfo, valSchemaVis } from "./entries";

const EventSetup = () => {
  const { hash } = useLocation();
  const history = useHistory();
  // ...
  const tabHashs = TABS_LIST.map((t) => t.hash);
  const hashIdx = tabHashs.indexOf(hash);
  const tabHashIdx = hashIdx !== -1 ? hashIdx : 0;
  const { data } = useEvent();
  const { data: dataR } = useRegFields();
  // ...
  const [currTab, setCurrTab] = useState(tabHashIdx);
  const [valSteps, setValSteps] = useState([false, false, false, false]);

  //# Handle Navigation
  const setCurrTabHandler = (idx) => {
    const hash = tabHashs[idx] || tabHashs[0];
    history.push(`/event-setup${hash}`);
  };
  // ...
  const onBackHandler = () => {
    const ps = currTab - 1;
    if (ps < 0) setCurrTab(1);
    setCurrTab(ps);
  };

  //#Validate Steps
  const onValidate = async () => {
    let _vals = [false, false, false];
    let _data = { ...data, ...dataR };
    // ...
    try {
      await valSchemaInfo.validate(_data);
      _vals[0] = true;
    } catch (err) {
      _vals[0] = false;
    }
    try {
      await valSchemaBrand.validate(_data);
      _vals[1] = true;
    } catch (err) {
      _vals[1] = false;
    }
    try {
      await valSchemaVis.validate(_data);
      _vals[2] = true;
    } catch (err) {
      _vals[2] = false;
    }
    // # Review Step
    _vals[3] = _data?.published;
    // ...
    setValSteps(_vals);
  };
  // ...
  useEffect(() => {
    setCurrTab(tabHashIdx);
  }, [hashIdx, tabHashIdx]);
  // ...
  useEffect(() => {
    onValidate();
  }, [data, dataR]);
  // ...
  return (
    <Page title="Event Informations">
      <Container>
        <Box>
          <EventSectionTitle
            title="Event Informations"
            subTitle="Add the primary event details and publish your event"
            src="/static/setup/title/setup.svg"
          />

          <EventSetupStepper
            isFree={data?.isFree}
            valSteps={valSteps}
            // ...
            currTab={currTab}
            setCurrTab={(step) => {
              setCurrTabHandler(step);
            }}
            ITEMS={TABS_LIST}
          />

          {TABS_LIST.map((tab, idx) => (
            <EventTabPanel key={idx} value={idx} currTab={currTab}>
              <tab.Node
                idx={idx}
                currTab={currTab}
                valSteps={valSteps}
                setCurrTab={setCurrTab}
                onBackHandler={onBackHandler}
                // ...
                setCurrTabHandler={setCurrTabHandler}
              />
            </EventTabPanel>
          ))}
        </Box>
      </Container>
    </Page>
  );
};

export default EventSetup;
